import { PrayEmailDomain, ApiEmailDomains, ApiEmailDomainResponse, PrayEmailDomainResponse } from '../types';

export const mapEmail = (emailResponse: ApiEmailDomains): PrayEmailDomain => {
  return {
    id: emailResponse.id,
    username: emailResponse.username,
    domain: emailResponse.domain,
    status: emailResponse.status,
    verified: emailResponse.verified,
    isPrimary: emailResponse.is_primary,
    createdAt: emailResponse.created_at,
    updatedAt: emailResponse.updated_at,
    sendgridDomainId: emailResponse.sendgrid_domain_id,
    sendgridIpPool: emailResponse.sendgrid_ip_pool,
    isPrayDomain: emailResponse.is_pray_domain,
    dnsRecords: emailResponse.dns_records,
    hasSetBrandingLink: emailResponse.has_set_branding_link,
    brandingDnsRecords: emailResponse.branding_dns_records,
  };
};

export const mapEmailDomainResponse = (emailDomainResponse: ApiEmailDomainResponse): PrayEmailDomainResponse => {
  return {
    domains: emailDomainResponse.domains.map(mapEmail),
    entriToken: emailDomainResponse.entri_token,
  };
};
